<template>
    <ClicColInterno
        :cp="cp"
        :key="componentKey"
    >
        <v-icon 
            :name="name"
            :scale="scale"
            :animation="animation"
            :speed="speed"
            :hover="hover"
            :flip="flip"
            :fill="fill"
            :label="label"
            :title="title"
            :inverse="inverse"
            v-if="!text"
            :style="[iconSizeStyle, style]"
            :class="this.class"
        />

        <b-avatar 
            variant="primary" 
            :text="text"
            v-if="text"
            :style="style"
            :class="this.class"
        >
        </b-avatar>

    </ClicColInterno>
</template>

<script>

    import ComponentMixin from '../../core/ComponentMixin';
    import { BAvatar } from 'bootstrap-vue';

    export default {
        name: 'ClicIcon',
        mixins: [ComponentMixin],
        components: { BAvatar },

        computed: {

            /* Ver ClicIconInterno: teto em px = maior dimensão real do ícone. */
            iconSizeStyle() {
                const tamanho = (Number(this.scale) || 1) * 16;

                return {
                    maxWidth: `${tamanho}px`,
                    maxHeight: `${tamanho}px`,
                };
            },

        },
    }
    
</script>
